import { useStore } from "effector-react";

import { useRef, useEffect } from "react";

import SiteStore, {
    extractContentField,
    track,
} from "reliance-private-sitebuilder-common/dist/stores/SiteStore";

import {
    getPhone,
    classNames,
    renderHTML,
} from "reliance-private-sitebuilder-common/dist/util/common-utilities";

export default function Home() {
    const myRef = useRef<null | HTMLDivElement>(null);

    const site_store = useStore(SiteStore);

    const scrollToForm = () => {
        myRef.current?.scrollIntoView();
        // track({ action: "click", what: "link", label: "yes", category: "form" });
        return false;
    };

    useEffect(() => {
        if (window) {
            window["scrollToForm"] = scrollToForm;
        }
    }, []);

    return (
        <>
            <div className={classNames("rounded-xl")}>
                <div
                    className={classNames(
                        extractContentField(site_store, "HEADER_DIV_WRAPPER")
                            .css ?? ""
                    )}
                >
                    <div
                        className={classNames(
                            !site_store.site.showFirm ? "hidden" : "",
                            "w-full text-center",
                            "xs:hidden",
                            extractContentField(
                                site_store,
                                "ADVERTISING_HEADER_SMALL"
                            ).css ?? ""
                        )}
                    >
                        <div
                            className={
                                extractContentField(
                                    site_store,
                                    "PAID_ATTORNEY_ADVERTISING"
                                ).css ?? ""
                            }
                        >
                            {renderHTML(
                                extractContentField(
                                    site_store,
                                    "PAID_ATTORNEY_ADVERTISING"
                                ).value
                                    ? extractContentField(
                                          site_store,
                                          "PAID_ATTORNEY_ADVERTISING"
                                      ).value +
                                          " " +
                                          site_store.site.firm?.name
                                    : ""
                            )}
                        </div>
                    </div>
                    <div
                        className={classNames(
                            "w-full p-2 grid grid-cols-5",
                            "xs:rounded-tl-md xs:rounded-tr-md",
                            "sm:rounded-tl-xl sm:rounded-tr-xl",
                            extractContentField(site_store, "TOP_HEADER").css ??
                                ""
                        )}
                    >
                        <div className={classNames("col-span-3")}>
                            <img
                                className={
                                    extractContentField(site_store, "LOGO")
                                        .css ?? ""
                                }
                                alt="logo"
                                src={`${site_store.strippedUri}/media/${
                                    extractContentField(site_store, "LOGO")
                                        .value
                                }`}
                            />
                        </div>
                        <div
                            className={classNames(
                                "col-span-2 grid items-center justify-items-center xs:justify-end"
                            )}
                        >
                            <button
                                className={classNames(
                                    extractContentField(site_store, "TOP_PHONE")
                                        .css ?? ""
                                )}
                            >
                                <a
                                    className={classNames("underline")}
                                    href={`tel:${getPhone(site_store)}`}
                                    onClick={() =>
                                        track({
                                            action: "click",
                                            what: "link",
                                            label: "yes",
                                            category: "phone",
                                        })
                                    }
                                >
                                    {getPhone(site_store)}
                                </a>
                            </button>
                        </div>
                    </div>
                </div>
                <div className={classNames("")}>
                    {renderHTML(
                        extractContentField(site_store, "MAIN_CONTENT").value ??
                            ""
                    )}
                </div>
            </div>
        </>
    );
}
